import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { ModelFormat } from "../../../Format";
import { ContractUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export type ContractPaymentProgressTextProps = {
	paymentProgress: ContractUtilities.PaymentProgressInformation;
} & Partial<ClassNameProps & StyleProps>;

export function ContractPaymentProgressText({ paymentProgress, className, style }: ContractPaymentProgressTextProps) {
	const { totalPrice, amountPaid } = paymentProgress;

	return (
		<div className={makeClassName(styles["payment-progress-text"], className)} style={style}>
			<span
				className={makeClassName(
					styles["payment-progress-text__amount-paid"],
					amountPaid > 0 ? styles["payment-progress-text__amount-paid--non-zero"] : "",
				)}
			>
				{ModelFormat.money(amountPaid)}
			</span>{" "}
			of {ModelFormat.money(totalPrice)}
		</div>
	);
}
